"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var __jsx = _react["default"].createElement;
var NextIcon = function NextIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.117 13.438l-6.542 6.99.876.82 7.87-8.41-7.87-8.41-.876.82 6.542 6.99H3.5v1.2h15.617z"
  }));
};
NextIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var CheckoutSteps = function CheckoutSteps(props) {
  var steps = props.steps,
    activeStep = props.activeStep,
    _props$font = props.font,
    font = _props$font === void 0 ? "body2" : _props$font;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var stepsNumber = steps.length;
  return __jsx(_Box["default"], {
    sx: {
      font: font,
      color: "main",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      alignItems: "center"
    }
  }, steps.map(function (step, index) {
    return __jsx(_Box["default"], {
      sx: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      key: "steps" + index
    }, index < activeStep ? __jsx(Link, {
      route: step.route
    }, __jsx(_LinkRaw["default"], {
      title: step.text
    }, __jsx(_Box["default"], {
      as: "span",
      sx: {
        color: "main",
        cursor: "pointer",
        textDecoration: "underline"
      }
    }, step.text))) : __jsx(_Box["default"], {
      as: "span",
      sx: {
        color: index == activeStep ? "active" : "neutral700"
      }
    }, step.text), index < stepsNumber - 1 && __jsx(_Box["default"], {
      as: "span",
      sx: {
        display: "flex",
        alignItems: "center",
        mx: "s6",
        svg: {
          transform: "scaleX(0.5) scaleY(0.5)"
        }
      }
    }, __jsx(NextIcon, null)));
  }));
};
var _default = CheckoutSteps;
exports["default"] = _default;